import "date-fns";
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "components/Table/Table";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "components/CustomButtons/Button.js";
import Chart from "components/Chart/Chart.js";
import Grid from '@material-ui/core/Grid';
import { getOrdersFilteredByMonthYear } from "../../services/orders/orders";
import CircularProgress from "../Circular/Circular";
import ExportCsv from "exportCsv.js";
import MomentUtils from "@date-io/date-fns";
import pt from "date-fns/locale/pt";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';

import './style.css';

const useStyles = (theme) => ({
  iconView: {
    color: "gray !important",
  },
  root: {
    "& .MuiFormControl-root": {
      margin: '2rem',
      width: 200,
    },
  },
  dialog: {
    "& .MuiPaper-root": {
      margin: theme.spacing(0),
      width: 250,
      height: 200,
    },
  },
  green: {
    "& label.Mui-focused": {
      color: "green",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
  },
  red: {
    "& label.Mui-focused": {
      color: "red",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "red",
    },
  },
});

class OccupancyRate extends Component {
  constructor(props) {
    super(props);
    this.getOrders = this.getOrders.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.getMinMax = this.getMinMax.bind(this);

    this.state = {
      selectedDate: null,
      sizes: [
        {
          value: "small",
          label: "Pequeno",
        },
        {
          value: "medium",
          label: "Médio",
        },
        {
          value: "large",
          label: "Grande",
        },
        {
          value: null,
          label: "Todos",
        }
      ],
      size: null,
      data: [],
      circular: true,
      chartData: [],
      dataExport: []
    };
  }

  componentDidMount() {
    this.getOrders();
  }

  handleDateChange(selectedDate) {
    this.setState({ selectedDate });
  }

  handleChange = (size) => {
    this.setState({ size: size.target.value });
  };

  handleExport = () => {
    const { dataExport } = this.state;
    ExportCsv(dataExport);
  };

  handleSearch = () => {
    let selectedDate = (this.state.selectedDate) ? new Date(this.state.selectedDate) : new Date();
    this.setState({ circular: true });
    this.getOrders(selectedDate.getFullYear(), (selectedDate.getMonth() + 1));
  };

  getOrders = (year = (new Date()).getFullYear(), month = ((new Date()).getMonth() + 1)) => {
    let data = [];
    let chartData = [];
    let dataExport = [];
    getOrdersFilteredByMonthYear(this.props.lockerId, year, month, (order) => {
      if (this.state.size)
        order = order.filter(o => o.size === this.state.size);

      let monthDays = new Date(year, month, 0).getDate();
      for (var i = 1; i <= monthDays; i++) {

        let minMax = this.getMinMax(order, `${month}/${i}/${year}`);

        data.push([`${i}/${month}/${year}`, `${minMax.max}%`]);
        dataExport.push({ Dia: `${i}/${month}/${year}`, 'Taxa de ocupação': `${minMax.max}%` })
        chartData.push({ year: `${i}`, min: minMax.min, max: minMax.max })
      }

      this.setState({ circular: false, data, chartData, dataExport });
    });
  }

  getMinMax = (order, date) => {
    let filteredOrdersEarly = order.filter(o => (o.collectedAt) ? new Date(o.collectedAt).getTime() > new Date(date).setHours(12, 0, 0, 0) : true);
    filteredOrdersEarly = filteredOrdersEarly.filter(o => new Date(o.allocatedAt).getTime() <= new Date(date).setHours(12, 0, 0, 0) && new Date(date).setHours(12, 0, 0, 0) <= new Date().setHours(12, 0, 0, 0));

    let filteredOrdersLater = order.filter(o => (o.collectedAt) ? new Date(o.collectedAt).getTime() > new Date(date).setHours(23, 59, 0, 0) : true);
    filteredOrdersLater = filteredOrdersLater.filter(o => new Date(o.allocatedAt).getTime() <= new Date(date).setHours(23, 59, 0, 0) && new Date(date).setHours(23, 59, 0, 0) <= new Date().setHours(23, 59, 0, 0));

    filteredOrdersEarly = Number(((filteredOrdersEarly.length / this.props.capacity) * 100).toFixed(2));
    filteredOrdersEarly = filteredOrdersEarly ? filteredOrdersEarly : 0;
    filteredOrdersLater = Number(((filteredOrdersLater.length / this.props.capacity) * 100).toFixed(2));
    filteredOrdersLater = filteredOrdersLater ? filteredOrdersLater : 0;

    return (filteredOrdersEarly > filteredOrdersLater) ?
      {
        max: filteredOrdersEarly,
        min: filteredOrdersLater
      } :
      {
        min: filteredOrdersEarly,
        max: filteredOrdersLater
      };
  }

  render() {
    const { classes } = this.props;
    const { selectedDate, sizes, size, data, circular, chartData } = this.state;

    let layout = (circular) ?
      <div className={classes.root}>
        <CircularProgress />
      </div>
      : <div>
        <h5>TAXA DE OCUPAÇÃO</h5>
        <div className="occupancy-top">
          <MuiPickersUtilsProvider utils={MomentUtils} locale={pt}>
            <Grid container justify="space-around">
              <KeyboardDatePicker
                locale="pt"
                variant="inline"
                openTo="month"
                views={["year", "month"]}
                label="Período"
                value={selectedDate}
                onChange={this.handleDateChange}
              />
            </Grid>
          </MuiPickersUtilsProvider>
          <TextField
            className={classes.green}
            id="outlined-size-input"
            select
            label="Tamanho"
            value={size}
            onChange={this.handleChange}
          >
            {sizes.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <Button onClick={this.handleSearch} color="primary">
            Pesquisar
            </Button>
          <div></div>
          <Button onClick={this.handleExport} color="default">
            Exportar
            </Button>
        </div>
        <div className="occupancy-down">
          <Table
            tableHeaderColor="primary"
            tableHead={["Dia", "Taxa de ocupação"]}
            tableData={data}

          />
          <div className="char-area">
            <Chart info={chartData} />
          </div>
        </div>
      </div>;

    return (
      <div>
        {layout}
      </div>
    );
  }
}
export default withStyles(useStyles)(OccupancyRate);
